import * as React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Chip,
  Alert,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { API_BASE_URL } from "../api/config";
import { rawFetch } from "../api/httpClient";

export const GamificationList = () => {
  const [patientId, setPatientId] = React.useState("");
  const [data, setData] = React.useState(null);
  const [bookingId, setBookingId] = React.useState("");
  const [feedbackStatus, setFeedbackStatus] = React.useState(null);

  const fetchGamification = async () => {
    if (!patientId.trim()) return;
    setData(null);
    try {
      const res = await rawFetch(`${API_BASE_URL}/patients/${patientId.trim()}/gamification`, {
        headers: { "X-React-Admin": "true" },
      });
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setData(json);
    } catch (e) {
      setData({ error: e.message });
    }
  };

  const fetchFeedbackStatus = async () => {
    if (!bookingId.trim()) return;
    setFeedbackStatus(null);
    try {
      const res = await rawFetch(`${API_BASE_URL}/consultations/${bookingId.trim()}/feedback/status`, {
        headers: { "X-React-Admin": "true" },
      });
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setFeedbackStatus(json);
    } catch (e) {
      setFeedbackStatus({ error: e.message });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <EmojiEventsIcon /> Gamification (ArcA, Talismans, Glyphes)
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Solde : GET /patients/{"{patientId}"}/gamification (arca, talismans, glyphs). Statut feedback : GET /consultations/{"{bookingId}"}/feedback/status.
      </Alert>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>Solde patient</Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <TextField size="small" label="ID Patient" value={patientId} onChange={(e) => setPatientId(e.target.value)} />
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={fetchGamification}>Charger</Button>
                </Grid>
              </Grid>
              {data && (
                <Box sx={{ mt: 2 }}>
                  {data.error ? (
                    <Typography color="error">{data.error}</Typography>
                  ) : (
                    <>
                      <Chip label={`ArcA: ${data.arca ?? "—"}`} sx={{ mr: 1 }} />
                      <Chip label={`Talismans: ${data.talismans ?? "—"}`} sx={{ mr: 1 }} />
                      <Typography variant="body2" sx={{ mt: 1 }}>Glyphes : {data.glyphs?.length ? JSON.stringify(data.glyphs) : "—"}</Typography>
                    </>
                  )}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>Feedback post-consultation (RDV)</Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <TextField size="small" label="ID Booking" value={bookingId} onChange={(e) => setBookingId(e.target.value)} />
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={fetchFeedbackStatus}>Statut</Button>
                </Grid>
              </Grid>
              {feedbackStatus && (
                <Box sx={{ mt: 2 }}>
                  {feedbackStatus.error ? (
                    <Typography color="error">{feedbackStatus.error}</Typography>
                  ) : (
                    <Typography variant="body2">
                      Soumis : {feedbackStatus.submitted ? "Oui" : "Non"} — ArcA gagnés : {feedbackStatus.arcaEarned ?? "—"} — À : {feedbackStatus.submittedAt ?? "—"}
                    </Typography>
                  )}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
